import React, {useState, useEffect} from 'react';
import AvatarEditor from 'react-avatar-editor';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import IconButton from '@mui/material/IconButton';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import baseStyles from '../../css/Base.module.css';
import {MIME_TYPE} from '../../constants';

export default function AvatarDialog({isOpen, handleClose, setNewAvatar}) {
  const [avatar, setAvatar] = useState(null);
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [mimeType, setMimeType] = useState(null);
  const [editorRef, setEditorRef] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setAvatar(null);
      setScale(1);
      setRotate(0);
    }
  }, [isOpen]);

  function isUploadButtonEnabled() {
    return !!avatar;
  }

  const handleChangeScale = (event, newScale) => {
    setScale(newScale);
  };

  function handleClickRotate() {
    setRotate(rotate + 90);
  }

  async function handleSave() {
    const dataURL = editorRef.getImageScaledToCanvas().toDataURL();
    const blob = await new Promise((res, rej) => {
      try {
        editorRef.getImageScaledToCanvas().toBlob(res);
      } catch (error) {
        rej(error);
      }
    });

    setNewAvatar({blob, mimeType, dataURL});
    handleClose();
  }

  function handleSelectFile(event) {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.addEventListener('load', () => {
      setAvatar(reader.result);
      setMimeType(file.type);
    });

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Profile Photo</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} justifyContent="center">
            {avatar && (
              <Grid item xs={12} style={{textAlign: 'center'}}>
                <AvatarEditor
                  ref={(editor) => {
                    setEditorRef(editor);
                  }}
                  width={350}
                  height={350}
                  scale={scale}
                  border={5}
                  color={[43, 45, 65]}
                  image={avatar}
                  rotate={rotate}
                />
              </Grid>
            )}
            <Grid item xs={12} style={{textAlign: 'center'}}>
              <input
                id="avatar-dialog-file-input"
                type="file"
                accept={`${MIME_TYPE.JPG}, ${MIME_TYPE.PNG}, ${MIME_TYPE.GIF}`}
                onChange={handleSelectFile}
                style={{display: 'none'}}
              />
              <label htmlFor="avatar-dialog-file-input">
                <Button variant="contained" component="span">
                  Select File
                </Button>
              </label>
            </Grid>
            {avatar && (
              <>
                <Grid item xs={12} style={{textAlign: 'center'}}>
                  <IconButton onClick={handleClickRotate} size="large">
                    <RotateRightIcon />
                  </IconButton>
                </Grid>

                <Grid item>
                  <ZoomOutIcon />
                </Grid>
                <Grid item xs={8}>
                  <Slider min={1} max={8} step={0.25} value={scale} onChange={handleChangeScale} />
                </Grid>
                <Grid item>
                  <ZoomInIcon />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button className={baseStyles['btn-pill']} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={baseStyles['btn-pill']}
            onClick={handleSave}
            variant="contained"
            disabled={!isUploadButtonEnabled()}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
